module.exports = __webpack_public_path__ + "img/heating.7c788abf.svg";